import CmsGuidePage, {
  type CmsGuidePageProps,
} from '@components/app/GuidePage/CmsGuidePage'
import ConjuredArticleGuidePage from '@components/app/GuidePage/ConjuredArticleGuidePage'
import { getGuidePageLayoutWithLayoutProps } from '@components/primitives/Layout/CmsLayout'
import Routes from '@lib/routes'
import { redirectGuideSlugWithICD10Code } from '@lib/routes/helpers/redirectGuideSlugWithICD10Code'
import getCachedConjuredArticlePageData from '@modules/conjuredArticles/cache/getCachedConjuredArticlePageData'
import type { ConjuredArticlePageData } from '@modules/conjuredArticles/helpers/getConjuredArticlePageData'
import getArticlePageData from '@modules/reactBricks/helpers/getArticlePageData'
import type { GetStaticPropsContext } from 'next'

export async function getStaticProps(context: GetStaticPropsContext) {
  const slug = (context.params?.slug ?? '') as string

  const redirect = redirectGuideSlugWithICD10Code(slug)
  if (redirect) {
    return redirect
  }

  try {
    const props =
      (await getCachedConjuredArticlePageData({ force: false, slug })) ??
      (await getArticlePageData(slug))
    return { props }
  } catch {
    return {
      notFound: true,
    }
  }
}

export async function getStaticPaths() {
  return { fallback: 'blocking', paths: [] }
}

function GuidePage(props: ConjuredArticlePageData | CmsGuidePageProps) {
  if ('page' in props) {
    return <CmsGuidePage {...props} />
  }

  if (!('content' in props)) {
    return { redirect: { destination: Routes.pageNotFound, permanent: false } }
  }

  return <ConjuredArticleGuidePage {...props} />
}

GuidePage.getLayout = getGuidePageLayoutWithLayoutProps({
  contentWidth: '',
  unstyled: true,
})

export default GuidePage
